export default __webpack_public_path__ + "static/media/credit_card_flags.448aecba.png";